import React from 'react'
import { biezacyRok, politykaPrywatnosciURL } from '../../lib/consts'

export default function StartFooter() {
  return (
    <>
      <div className="copyright">
        <p className="disabled-subtitle-2">
          © {biezacyRok} RAKS Spółka z o.o. wszystkie prawa zastrzeżone.
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={politykaPrywatnosciURL}
          className="disabled-subtitle-2"
        >
          Polityka prywatności
        </a>
      </div>
    </>
  )
}
